import React, { useEffect } from 'react';
import styled from 'styled-components';
import { font, colors, spacing } from '@growth/app-theme';

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
var ErrorWrap = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\n\timg {\n\t\tmargin-bottom: 35px;\n\t}\n"])));
var Title = styled.p(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n\tfont-size: 16px;\n\n\tfont-weight: 500;\n\tcolor: #141823;\n\tmargin-bottom: 5px;\n"])));
var SubTitle = styled.p(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n\tfont-size: 12px;\n\n\tcolor: #46484d;\n\tmargin-bottom: 20px;\n"])));
var LinkText = styled.a(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n\tcolor: #2276e3;\n\tfont-weight: 500;\n\tfont-size: 12px;\n"])));
var ErrorCode = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n\tfont-size: ", ";\n\tcolor: ", ";\n\n\tfont-weight: 500;\n"])), font.token.Large, colors.goBrandBlue.medium);
var NavigationList = styled.ul(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n\tfont-size: ", ";\n\tdisplay: flex;\n\tmargin-top: 24px;\n\tfont-size: 1rem;\n\n\t> li {\n\t\tdisplay: flex;\n\t\t&:last-child {\n\t\t\tborder-right: none;\n\t\t}\n\t}\n"])), font.token.BaseW2);
var ListItem = styled.a(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n\tpadding: 0 ", ";\n\tborder-right: 1px solid ", ";\n\tfont-size: 1rem;\n"])), spacing.small, colors.ash.dark);

var error404 = {
  code: '404',
  title: 'You\'ve landed in No Man\'s Land!',
  subTitle: 'We\'re sorry. The page that you are looking for does not exist',
  imageUrl: 'https://gos3.ibcdn.com/error-1652699149.png',
  goBack: 'Go Back to',
  lobs: [{
    name: 'Flights',
    link: '/flights'
  }, {
    name: 'Buses',
    link: '/bus'
  }, {
    name: 'Hotels',
    link: '/hotels'
  }, {
    name: 'Trains',
    link: '/trains'
  }]
};
var genericError = {
  title: 'Something went wrong',
  subTitle: 'Try reloading the page.',
  reload: 'Reload',
  imageUrl: 'https://gos3.ibcdn.com/error-1652699149.png'
};

var ErrorPage404 = function ErrorPage404() {
  return /*#__PURE__*/React.createElement(ErrorWrap, null, /*#__PURE__*/React.createElement("img", {
    alt: "Page not found! - 404",
    src: error404.imageUrl,
    width: "176",
    height: "176"
  }), /*#__PURE__*/React.createElement(ErrorCode, null, error404.code), /*#__PURE__*/React.createElement(Title, null, error404.title), /*#__PURE__*/React.createElement(SubTitle, null, error404.subTitle), /*#__PURE__*/React.createElement(NavigationList, null, error404.goBack, error404.lobs.map(function (lob) {
    return /*#__PURE__*/React.createElement("li", {
      key: lob.name
    }, /*#__PURE__*/React.createElement(ListItem, {
      href: lob.link
    }, lob.name));
  })));
};

var GenericErrorBlock = function GenericErrorBlock(_ref) {
  var onReloadClick = _ref.onReloadClick,
      style = _ref.style,
      onLoad = _ref.onLoad;
  useEffect(function () {
    onLoad == null ? void 0 : onLoad();
  }, []);
  return /*#__PURE__*/React.createElement(ErrorWrap, {
    style: style
  }, /*#__PURE__*/React.createElement("img", {
    alt: "error",
    src: genericError.imageUrl,
    width: "176",
    height: "176"
  }), /*#__PURE__*/React.createElement(Title, null, " ", genericError.title), /*#__PURE__*/React.createElement(SubTitle, null, genericError.subTitle), /*#__PURE__*/React.createElement(LinkText, {
    onClick: function onClick() {
      return onReloadClick ? onReloadClick() : function () {};
    }
  }, genericError.reload));
};

GenericErrorBlock.defaultProps = {
  style: undefined,
  onLoad: undefined
};

export { ErrorPage404, GenericErrorBlock };
